import React from 'react';
// import { FemaleSeatIcon } from './icons/svg';
import { renderImg } from './icons/img';

const FemaleSeatAlert = ({ close }) => {
    return (
        <div className='alert'>
            <div className='alert--wrap'>
                <div
                    className={`alert--wrap--top`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className='alert--wrap--icon'>
                        {/* <FemaleSeatIcon /> */}
                        {renderImg('FemaleSeatIcon')}
                    </div>
                    <div>
                        You have selected a female seat <br /> Please confirm if you want to proceed
                    </div>
                </div>
                <div className="alert--wrap--bottom">
                    <div onClick={(e) => close('cancel', e)}>CANCEL</div>
                    <div onClick={(e) => close('confirm', e)}>CONFIRM</div>
                </div>
            </div>
        </div>
    )
}

export default FemaleSeatAlert;